import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Button, Form } from '_zari/core'

import * as TransaccionCrud from 'services/transaccion.service'

import * as FormGroups from './formGroups'
import { ValidationSchema } from './validation'

const EditarModal = ({ modalData, handleClose, show, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      codigo: modalData.codigo,
      descripcion: modalData.descripcion
    }),
    [modalData]
  )

  const submitHandler = async data => {
    await TransaccionCrud.actualizarTransaccion(modalData._id, data)
      .then(() => {
        __zariContext.snack('success', 'El registro se ha actualizado.')
        reloadTable()
        handleClose()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <Modal show={show} onHide={handleClose} size='sm'>
      <Modal.Header>
        <Modal.Title>EDITAR TRANSACCION</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched, values }) => (
          <Form>
            <Modal.Body>
              <FormGroups.CodigoFormGroup fIsSubmitting={isSubmitting} iValue={values.codigo} />
              <FormGroups.DescripcionFormGroup iError={errors.descripcion} iTouched={touched.descripcion} fIsSubmitting={isSubmitting} />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Actualizar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default EditarModal
